export const getPersonItemRowId = (person) => {
  return `person-item-${person.aggregateId}`;
};
